import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "awsS3",
  "name": "AWS S3",
  "category": "integrations",
  "description": "Upload and manage files in Amazon S3",
  "icon": "siAmazons3",
  "iconType": "simple-icon",
  "color": "orange",
  "version": "1.4.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "AWS S3",
    "color": "#ff9900"
  },
  "credentials": [
    {
      "name": "awsS3",
      "required": true,
      "displayName": "AWS S3"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "aws",
    "s3",
    "storage",
    "files",
    "bucket"
  ],
  "comingSoon": true
};

export default definition;
